/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Area Restrita API
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  BuslineDetailQueryResponse,
  BuslineQueryResponse,
  CreateBuslineCommand,
  CreateBuslineCommandResponse,
  EditBuslineBody,
  EditBuslineCommandResponse,
  GetBuslinesParams
} from '../../model';

import { instance } from '../../index';
import type { ErrorType, BodyType } from '../../index';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getBuslines = (
    params: GetBuslinesParams,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<BuslineQueryResponse>(
      {url: `/api/v1/buslines`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetBuslinesQueryKey = (params: GetBuslinesParams,) => {
    return [`/api/v1/buslines`, ...(params ? [params]: [])] as const;
    }

    
export const getGetBuslinesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getBuslines>>, GetBuslinesParams['page']>, TError = ErrorType<unknown>>(params: GetBuslinesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBuslines>>, TError, TData, Awaited<ReturnType<typeof getBuslines>>, QueryKey, GetBuslinesParams['page']>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBuslinesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBuslines>>, QueryKey, GetBuslinesParams['page']> = ({ signal, pageParam }) => getBuslines({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBuslines>>, TError, TData, Awaited<ReturnType<typeof getBuslines>>, QueryKey, GetBuslinesParams['page']> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetBuslinesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getBuslines>>>
export type GetBuslinesInfiniteQueryError = ErrorType<unknown>


export function useGetBuslinesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBuslines>>, GetBuslinesParams['page']>, TError = ErrorType<unknown>>(
 params: GetBuslinesParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBuslines>>, TError, TData, Awaited<ReturnType<typeof getBuslines>>, QueryKey, GetBuslinesParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBuslines>>,
          TError,
          Awaited<ReturnType<typeof getBuslines>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBuslinesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBuslines>>, GetBuslinesParams['page']>, TError = ErrorType<unknown>>(
 params: GetBuslinesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBuslines>>, TError, TData, Awaited<ReturnType<typeof getBuslines>>, QueryKey, GetBuslinesParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBuslines>>,
          TError,
          Awaited<ReturnType<typeof getBuslines>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBuslinesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBuslines>>, GetBuslinesParams['page']>, TError = ErrorType<unknown>>(
 params: GetBuslinesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBuslines>>, TError, TData, Awaited<ReturnType<typeof getBuslines>>, QueryKey, GetBuslinesParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetBuslinesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBuslines>>, GetBuslinesParams['page']>, TError = ErrorType<unknown>>(
 params: GetBuslinesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBuslines>>, TError, TData, Awaited<ReturnType<typeof getBuslines>>, QueryKey, GetBuslinesParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetBuslinesInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetBuslinesQueryOptions = <TData = Awaited<ReturnType<typeof getBuslines>>, TError = ErrorType<unknown>>(params: GetBuslinesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBuslines>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBuslinesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBuslines>>> = ({ signal }) => getBuslines(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBuslines>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetBuslinesQueryResult = NonNullable<Awaited<ReturnType<typeof getBuslines>>>
export type GetBuslinesQueryError = ErrorType<unknown>


export function useGetBuslines<TData = Awaited<ReturnType<typeof getBuslines>>, TError = ErrorType<unknown>>(
 params: GetBuslinesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBuslines>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBuslines>>,
          TError,
          Awaited<ReturnType<typeof getBuslines>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBuslines<TData = Awaited<ReturnType<typeof getBuslines>>, TError = ErrorType<unknown>>(
 params: GetBuslinesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBuslines>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBuslines>>,
          TError,
          Awaited<ReturnType<typeof getBuslines>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBuslines<TData = Awaited<ReturnType<typeof getBuslines>>, TError = ErrorType<unknown>>(
 params: GetBuslinesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBuslines>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetBuslines<TData = Awaited<ReturnType<typeof getBuslines>>, TError = ErrorType<unknown>>(
 params: GetBuslinesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBuslines>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetBuslinesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetBuslinesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getBuslines>>, TError = ErrorType<unknown>>(params: GetBuslinesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBuslines>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBuslinesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBuslines>>> = ({ signal }) => getBuslines(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBuslines>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetBuslinesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getBuslines>>>
export type GetBuslinesSuspenseQueryError = ErrorType<unknown>


export function useGetBuslinesSuspense<TData = Awaited<ReturnType<typeof getBuslines>>, TError = ErrorType<unknown>>(
 params: GetBuslinesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBuslines>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBuslinesSuspense<TData = Awaited<ReturnType<typeof getBuslines>>, TError = ErrorType<unknown>>(
 params: GetBuslinesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBuslines>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBuslinesSuspense<TData = Awaited<ReturnType<typeof getBuslines>>, TError = ErrorType<unknown>>(
 params: GetBuslinesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBuslines>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetBuslinesSuspense<TData = Awaited<ReturnType<typeof getBuslines>>, TError = ErrorType<unknown>>(
 params: GetBuslinesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBuslines>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetBuslinesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const createBusline = (
    createBuslineCommand: BodyType<CreateBuslineCommand>,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<CreateBuslineCommandResponse>(
      {url: `/api/v1/buslines`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createBuslineCommand, signal
    },
      options);
    }
  


export const getCreateBuslineMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBusline>>, TError,{data: BodyType<CreateBuslineCommand>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof createBusline>>, TError,{data: BodyType<CreateBuslineCommand>}, TContext> => {
    
const mutationKey = ['createBusline'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBusline>>, {data: BodyType<CreateBuslineCommand>}> = (props) => {
          const {data} = props ?? {};

          return  createBusline(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateBuslineMutationResult = NonNullable<Awaited<ReturnType<typeof createBusline>>>
    export type CreateBuslineMutationBody = BodyType<CreateBuslineCommand>
    export type CreateBuslineMutationError = ErrorType<unknown>

    export const useCreateBusline = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBusline>>, TError,{data: BodyType<CreateBuslineCommand>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof createBusline>>,
        TError,
        {data: BodyType<CreateBuslineCommand>},
        TContext
      > => {

      const mutationOptions = getCreateBuslineMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getBusline = (
    id: number,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<BuslineDetailQueryResponse>(
      {url: `/api/v1/buslines/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetBuslineQueryKey = (id: number,) => {
    return [`/api/v1/buslines/${id}`] as const;
    }

    
export const getGetBuslineInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getBusline>>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBusline>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBuslineQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBusline>>> = ({ signal }) => getBusline(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBusline>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetBuslineInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getBusline>>>
export type GetBuslineInfiniteQueryError = ErrorType<unknown>


export function useGetBuslineInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBusline>>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBusline>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusline>>,
          TError,
          Awaited<ReturnType<typeof getBusline>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBuslineInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBusline>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBusline>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusline>>,
          TError,
          Awaited<ReturnType<typeof getBusline>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBuslineInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBusline>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBusline>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetBuslineInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBusline>>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBusline>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetBuslineInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetBuslineQueryOptions = <TData = Awaited<ReturnType<typeof getBusline>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusline>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBuslineQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBusline>>> = ({ signal }) => getBusline(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBusline>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetBuslineQueryResult = NonNullable<Awaited<ReturnType<typeof getBusline>>>
export type GetBuslineQueryError = ErrorType<unknown>


export function useGetBusline<TData = Awaited<ReturnType<typeof getBusline>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusline>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusline>>,
          TError,
          Awaited<ReturnType<typeof getBusline>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBusline<TData = Awaited<ReturnType<typeof getBusline>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusline>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusline>>,
          TError,
          Awaited<ReturnType<typeof getBusline>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBusline<TData = Awaited<ReturnType<typeof getBusline>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusline>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetBusline<TData = Awaited<ReturnType<typeof getBusline>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusline>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetBuslineQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetBuslineSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getBusline>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBusline>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBuslineQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBusline>>> = ({ signal }) => getBusline(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBusline>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetBuslineSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getBusline>>>
export type GetBuslineSuspenseQueryError = ErrorType<unknown>


export function useGetBuslineSuspense<TData = Awaited<ReturnType<typeof getBusline>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBusline>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBuslineSuspense<TData = Awaited<ReturnType<typeof getBusline>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBusline>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBuslineSuspense<TData = Awaited<ReturnType<typeof getBusline>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBusline>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetBuslineSuspense<TData = Awaited<ReturnType<typeof getBusline>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getBusline>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetBuslineSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const updateBusline = (
    id: number,
    editBuslineBody: BodyType<EditBuslineBody>,
 options?: SecondParameter<typeof instance>,) => {
      
      
      return instance<EditBuslineCommandResponse>(
      {url: `/api/v1/buslines/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: editBuslineBody
    },
      options);
    }
  


export const getUpdateBuslineMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBusline>>, TError,{id: number;data: BodyType<EditBuslineBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateBusline>>, TError,{id: number;data: BodyType<EditBuslineBody>}, TContext> => {
    
const mutationKey = ['updateBusline'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateBusline>>, {id: number;data: BodyType<EditBuslineBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateBusline(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateBuslineMutationResult = NonNullable<Awaited<ReturnType<typeof updateBusline>>>
    export type UpdateBuslineMutationBody = BodyType<EditBuslineBody>
    export type UpdateBuslineMutationError = ErrorType<unknown>

    export const useUpdateBusline = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBusline>>, TError,{id: number;data: BodyType<EditBuslineBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateBusline>>,
        TError,
        {id: number;data: BodyType<EditBuslineBody>},
        TContext
      > => {

      const mutationOptions = getUpdateBuslineMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const deleteBusline = (
    id: number,
 options?: SecondParameter<typeof instance>,) => {
      
      
      return instance<void>(
      {url: `/api/v1/buslines/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteBuslineMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBusline>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteBusline>>, TError,{id: number}, TContext> => {
    
const mutationKey = ['deleteBusline'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBusline>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteBusline(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteBuslineMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBusline>>>
    
    export type DeleteBuslineMutationError = ErrorType<unknown>

    export const useDeleteBusline = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBusline>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteBusline>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getDeleteBuslineMutationOptions(options);

      return useMutation(mutationOptions);
    }
    